import { VirtualMultiselectCheckbox } from './components/VirtualMultiselectCheckbox';
import { VirtualMultiselectItem } from './components/VirtualMultiselectItem';
import { VirtualMultiselectRoot } from './components/VirtualMultiselectRoot';
import { VirtualMultiselectSelectAllButton } from './components/VirtualMultiselectSelectAllButton';
import { VirtualMultiselectToggleButton } from './components/VirtualMultiselectToggleButton';
import { VirtualMultiselectWindow } from './components/VirtualMultiselectWindow';

export const VirtualMultiselect = {
  Checkbox: VirtualMultiselectCheckbox,
  Item: VirtualMultiselectItem,
  Root: VirtualMultiselectRoot,
  SelectAllButton: VirtualMultiselectSelectAllButton,
  ToggleButton: VirtualMultiselectToggleButton,
  Window: VirtualMultiselectWindow,
};
